function joinParts(...parts) {
  return parts.map((part) => (part == null ? "" : String(part).trim())).filter(Boolean);
}

export function flattenTeacherManualSlideForPdf(slide) {
  switch (slide?.kind) {
    case "cover":
    case "divider":
      return {
        kind: "title",
        title: slide.title,
        subtitle: joinParts(slide.kicker, slide.subtitle).join("\n"),
      };
    case "overview": {
      const bullets = [];
      if (slide.highlight?.title) {
        bullets.push(
          joinParts(
            slide.highlight.title,
            slide.highlight.accent,
            slide.highlight.body,
          ).join(" — "),
        );
      }
      for (const item of slide.list?.items ?? []) {
        bullets.push(joinParts(item.label, item.text).join(" "));
      }
      return {
        kind: "bullets",
        title: slide.title,
        body: joinParts(slide.subtitle, slide.focal?.title, slide.focal?.body).join(
          "\n\n",
        ),
        bullets,
      };
    }
    case "compare": {
      const bullets = [];
      if (slide.left) {
        bullets.push(
          joinParts(slide.left.badge, slide.left.title, slide.left.body).join(": "),
        );
        bullets.push(...(slide.left.bullets ?? []));
      }
      if (slide.right) {
        bullets.push(
          joinParts(slide.right.badge, slide.right.title, slide.right.body).join(": "),
        );
        bullets.push(...(slide.right.bullets ?? []));
      }
      return {
        kind: "bullets",
        title: slide.title,
        body: slide.subtitle,
        bullets,
      };
    }
    case "steps":
      return {
        kind: "bullets",
        title: slide.title,
        body: slide.subtitle,
        bullets: (slide.steps ?? []).map((step) =>
          joinParts(
            step.title,
            step.metaValue ? `(${step.metaValue})` : "",
            step.body,
          ).join(" — "),
        ),
      };
    case "media":
      return {
        kind: "section",
        title: slide.title,
        lead: slide.heading,
        body: joinParts(slide.body, slide.callout, slide.takeaway).join("\n\n"),
      };
    default:
      return slide;
  }
}

export function flattenExportSlidesForPdf(slides = []) {
  return slides.map(flattenTeacherManualSlideForPdf);
}
